import {Params} from '@angular/router';

// import moment, {Moment} from 'moment';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {CourtModel} from './court.model';
import {DrawingModel} from './drawing.model';
import {ScoreModel} from './score.model';
import {TeamModel} from './team.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'gameId',
  eventId: 'eventId',
  tournamentCategoryId: 'tournamentCategoryId',
  courtId: 'courtId',
  locationId: 'locationId',
  stage: 'stage',
  group: 'group',
  drawing1Id: 'drawing1Id',
  drawing2Id: 'drawing2Id',
  date: 'date',
  startDate: 'startDate',
  endDate: 'endDate',
  winner: 'winner',
  day: 'day',
  sort: 'sort',
  status: 'status',

  court: 'court',
  // location: 'location',
  drawing1: 'drawing1',
  drawing2: 'drawing2',
  scores: 'scores',
};

export class GameModel extends Model {
  eventId!: number;
  tournamentCategoryId!: number;
  courtId!: number;
  locationId!: number;
  stage!: string;
  group!: number;
  drawing1Id!: number;
  drawing2Id!: number;
  date!: Date;
  startDate!: Date;
  endDate!: Date;
  winner!: number;
  day!: number;
  sort!: number;
  status!: string;

  court?: CourtModel;
  drawing1?: DrawingModel;
  drawing2?: DrawingModel;
  scores?: ScoreModel[];
  duration?: string;

  get avatarImg1(): string {
    if (!this.drawing1?.team) {
      // Imagen por defecto
      return 'player.png';
    }

    const team: TeamModel = this.drawing1.team;

    if (team.teamAvatar) {
      return String((team.teamAvatar % 30) + 1) + '.png';
    }

    if (team.playerAvatar) {
      return String((team.playerAvatar % 30) + 1) + '.png';
    }

    if (this.drawing1?.team?.name) {
      // Imagen por defecto del equipo
      return 'team.png';
    }

    // Imagen por defecto del jugador
    // @TODO: validar el genero del jugador para mostrar un avatar femenino
    // o masculino
    return 'player.png';
  }

  get avatarImg2(): string {
    if (!this.drawing2?.team) {
      // Imagen por defecto
      return 'player.png';
    }

    const team: TeamModel = this.drawing2.team;

    if (team.teamAvatar) {
      return String((team.teamAvatar % 30) + 1) + '.png';
    }

    if (team.playerAvatar) {
      return String((team.playerAvatar % 30) + 1) + '.png';
    }

    if (this.drawing2?.team?.name) {
      // Imagen por defecto del equipo
      return 'team.png';
    }

    // Imagen por defecto del jugador
    // @TODO: validar el genero del jugador para mostrar un avatar femenino
    // o masculino
    return 'player.png';
  }

  static getInstance(data: Params): GameModel {
    const model = new GameModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (['date', 'startDate', 'endDate'].includes(prop)) {
        // Hace la correccion de la zona horaria del cliente
        const date = new Date(data[propsMapping[prop]]);
        // @TODO: revisar
        // date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        (model as Params)[prop] = date;
      } else if (prop === 'court') {
        (model as Params)[prop] = CourtModel.getInstance(data[propsMapping[prop]]);
      // } else if (prop === 'location') {
      //   (model as Params)[prop] = LocationModel.getInstance(data[propsMapping[prop]]);
      } else if (['drawing1', 'drawing2'].includes(prop)) {
        (model as Params)[prop] = DrawingModel.getInstance(data[propsMapping[prop]]);
      } else if (prop === 'scores') {
        if (Array.isArray(data[propsMapping[prop]])) {
          (model as Params)[prop] = data[propsMapping[prop]].map((item: Params) => {
            return ScoreModel.getInstance(item);
          });
        }
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    if (!Array.isArray(model.scores)) {
      model.scores = [];
    }

    // @TODO: descomentar
    // if (model.startDate && model.endDate) {
    //   const startDate: Moment = moment(model.startDate);
    //   const endDate: Moment = moment(model.endDate);
    //   const diff: number = endDate.diff(startDate, 'minutes');
    //   const hours: number = Math.floor(diff / 60);
    //   const minutes: number = diff % 60;
    //   model.duration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    // }

    return model;
  }

  // static search(
  //   apiService: ApiService,
  //   tournamentId: number,
  //   urlParams?: HttpParams
  // ): Observable<ListState<GameModel>> {
  //   return apiService
  //     .get(`tournaments/${tournamentId}/games`, urlParams)
  //     .pipe(
  //       map((data: Params): ListState<GameModel> => {
  //         const list: GameModel[] = data['data'].map((item: Params): GameModel =>
  //           GameModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }
}
